import { useMutation, useQueryClient } from 'react-query'

import { unSdgService } from 'src/services/un-sdg.service'
import { IFilter } from 'src/components/filter/types/filter.types'
import { IUnSdgRespDto } from 'src/types'

import { QUERY_KEYS } from 'src/constants'

const useUpdateUnSdgOrder = (filter: IFilter) => {
  const queryClient = useQueryClient()

  return useMutation((ids: string[]) => unSdgService.updateUnSdgOrder(ids), {
    onMutate(ids) {
      queryClient.setQueryData([QUERY_KEYS.UN_SDGS, filter], (prev?: IUnSdgRespDto) => {
        if (!prev) return []

        return ids.map((id) => prev.find((item) => item.id === id)!)
      })
    },
  })
}

export { useUpdateUnSdgOrder }
